import { IAdpBatchInfo } from "./adp-batch-info";

export interface IAdpBatchInfoResponse {
    data: {
        success: boolean;
        message: string;
        results: IAdpBatchInfo[]
    }
}